import react from "react";
import { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { Redirect, useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import logo from '../../../resources/img/logo-2.png';

function CuestionarioPaciente1() {
    
    const [estadoCheck, setEstadocheck] = useState(false);

    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');

    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [genero, setGenero] = useState('');
    const [identidadGenero, setIdentidadGenero] = useState('');
    const [tipoSangre, setTipoSangre] = useState('');
    


    const queryParams = useLocation().search;

    const [idPaciente, setIdPaciente] = useState(new URLSearchParams(queryParams).get('id'));
    const [emailPaciente, setEmailPaciente] = useState(new URLSearchParams(queryParams).get('email'));
    const [tokenPaciente, setTokenPaciente] = useState(new URLSearchParams(queryParams).get('token'));

    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState();

    let history = useHistory();

    useEffect(() => {

        const config = {
            params: {
                id: idPaciente
            }
        }

        axios.get('/paciente-publico',config)
            .then(response => {
                setPrimerNombre(response.data[0].primer_nombre);
                setSegundoNombre(response.data[0].segundo_nombre);
                setPrimerApellido(response.data[0].primer_apellido);
                setSegundoApellido(response.data[0].segundo_apellido);
                setNumeroDocumento(response.data[0].numero_documento);
                setTipoDocumento(response.data[0].tipo_documento);
                setGenero(response.data[0].sexo);
                setIdentidadGenero(response.data[0].identidad_genero);
                setTipoSangre(response.data[0].rh);
            })
            .catch(error => {
                console.log(error);
            })
    },[]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const config = {
            id:idPaciente,
            primer_nombre:primerNombre,
            segundo_nombre: segundoNombre, 
            primer_apellido: primerApellido, 
            segundo_apellido: segundoApellido, 
            numero_documento: numeroDocumento,
            tipo_documento: tipoDocumento,
            sexo: genero,
            identidad_genero: identidadGenero,
            rh: tipoSangre
        }

        axios.put('/datos-personales',config)
            .then(response => {
                setLoading(false);

                history.push({
                    pathname: '/cuestionario-paciente2',
                    search: '?id='+idPaciente
                });
            })
            .catch(error => {
                console.log(error.response.data);
                setErrorlist(error.response.data.errors);
            })
    }

    
    function handleCheck() {
        estadoCheck ? setEstadocheck(false) : setEstadocheck(true);
    }

    useEffect(() => {
        console.log('estado check: '+estadoCheck);
    },[estadoCheck]);

    
    return (
            
                <div className="contenedor-cuestionario">

                    <div style={{textAlign:'center'}}>
                        <img src={logo} alt="logo smile" width="200" />
                    </div>
                    
                    <div className="row mb-2" style={{marginTop:'30px'}}>
                        <h1 className="m-0" style={{textAlign: 'center', width: '100%'}}>Información personal</h1>
                    </div>

                    <div className="indicador-progreso">
                        <div className="indicador-punto completado">1</div>
                        <div className="indicador-linea"></div>
                        <div className="indicador-punto">2</div>
                        <div className="indicador-linea"></div>
                        <div className="indicador-punto">3</div>
                        <div className="indicador-linea"></div>
                        <div className="indicador-punto">4</div>
                    </div>

                    <form id="quickForm" onSubmit={handleSubmit} autoComplete="off">
                        
                        <div className="card cuestionario-paciente">
                            <div className="card-header">
                                <h4 className="card-title w-100">
                                <a className="d-block w-100" data-toggle="collapse" data-target="#infobasica" href="#" style={{textAlign:'center'}}>
                                    Datos Personales
                                </a>
                                </h4>
                            </div>
                            <div id="infobasica" className="collapse show">
                                <div className="card-body">

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="companyName">Primer nombre</label>
                                                <input type="text" name="company-name" className="form-control" id="companyName" value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)}/>
                                                <div className="invalid-feedback visible">
                                                {errorlist.primer_nombre}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="companyName">Segundo nombre</label>
                                                <input type="text" name="company-name" className="form-control" id="companyName" value={segundoNombre} onChange={(e) => setSegundoNombre(e.target.value)}/>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="companyName">Primer apellido</label>
                                                <input type="text" name="company-name" className="form-control" id="companyName" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)}/>
                                                <div className="invalid-feedback visible">
                                                {errorlist.primer_apellido}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="companyName">Segundo apellido</label>
                                                <input type="text" name="company-name" className="form-control" id="companyName" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="companyName">Número de documento</label>
                                                <input type="text" name="company-name" className="form-control" id="companyName" value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
                                                <div className="invalid-feedback visible">
                                                {errorlist.numero_documento}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="companyName">Tipo documento</label>
                                                <select name="company-name" className="form-control" id="tipoDoc" value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)}>
                                                    <option value="CC">CC - CEDULA DE CIUDADANIA</option>
                                                    <option value="CE">CE - CEDULA DE EXTRANJERIA</option>
                                                    <option value="CD">CD - CARNET DIPLOMATICO</option>
                                                    <option value="CN">CN - CERTIFICADO DE NACIDO VIVO</option>
                                                    <option value="DE">DE - DOCUMENTOS EXTRANJERO</option>
                                                    <option value="MS">MS - MENOR SIN IDENTIFICAR</option>
                                                    <option value="NIP">NIP - NUMERO DE IDENTIFICACION PERSONAL</option>
                                                    <option value="NIT">NIT - NUMERO DE IDENTIFICACION TRIBUTARIA</option>
                                                    <option value="PA">PA - PASAPORTE</option>
                                                    <option value="PT">PT - PERMISO TEMPORAL DE PERMANENCIA</option>
                                                    <option value="PE">PE - PERMISO ESPECIAL DE PERMANENCIA</option>
                                                    <option value="RC">RC - REGISTRO CIVIL</option>
                                                    <option value="TI">TI - TARJETA DE IDENTIDAD</option>
                                                    <option value="SC">SC - SALVOCONDUCTO DE PERMANENCIA</option>
                                                    <option value="SI">SI - SIN IDENTIFICACION</option>
                                                    <option value="AS">AS - ADULTO SIN IDENTIFICAR</option>
                                                </select>
                                                <div className="invalid-feedback visible">
                                                {errorlist.tipo_documento}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="genero">Sexo biológico</label>
                                                <select name="genero" className="form-control" id="genero" value={genero} onChange={(e) => setGenero(e.target.value)}>
                                                    <option value=""></option>
                                                    <option value="01">HOMBRE</option>
                                                    <option value="02">MUJER</option>
                                                    <option value="03">INDETERMINADO/INTERSEXUAL</option>
                                                </select>
                                                <div className="invalid-feedback visible">
                                                {errorlist.sexo}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="identidad">Identidad de género</label>
                                                <select name="identidad" className="form-control" id="identidad" value={identidadGenero} onChange={(e) => setIdentidadGenero(e.target.value)}>
                                                    <option value=""></option>
                                                    <option value="01">MASCULINO</option>
                                                    <option value="02">FEMENINO</option>
                                                    <option value="03">TRANSGÉNERO</option>
                                                    <option value="04">NEUTRO</option>
                                                    <option value="05">NO LO DECLARA</option>
                                                </select>
                                                <div className="invalid-feedback visible">
                                                {errorlist.identidad_genero}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="tipoSangre">Tipo de sangre</label>
                                                <select name="tipo-sangre" className="form-control" id="tipoSangre" value={tipoSangre} onChange={(e) => setTipoSangre(e.target.value)}>
                                                    <option value=""></option>
                                                    <option value="a+">A+</option>
                                                    <option value="a-">A-</option>
                                                    <option value="b+">B+</option>
                                                    <option value="b-">B-</option>
                                                    <option value="ab+">AB+</option>
                                                    <option value="ab-">AB-</option>
                                                    <option value="o+">O+</option>
                                                    <option value="o-">O-</option>
                                                </select>
                                                <div className="invalid-feedback visible">
                                                {errorlist.rh}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12" style={{textAlign:'center'}}>
                                            <input type="checkbox" name="acepto-politica" id="acepto-politica" onChange={() => handleCheck()} />
                                            <label htmlFor="acepto-politica">&nbsp;Acepto la <a href="http://www.brand-works.co/smile/politica-tratamiento-datos-personales.pdf" target="_blank">política de tratamiento de datos personales</a></label>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <button type="submit" className="btn btn-primary" style={{margin: '0 auto', fontSize: '1.4rem'}} disabled={!estadoCheck}>
                                Continuar&nbsp;
                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                            </button>
                        </div>
                    </form>
                </div>
                
    );
}
export default CuestionarioPaciente1;